export const activateInputFile = (file_input_id) => {
  document.querySelector(file_input_id).click()
}